/**
 * @version 1.3.0
 * @updated 2026-10-02
 * theme-custom.js — テーマカスタム JS（カート / お気に入り / VIP 等）
 *
 * Changelog:
 * - 1.3.0: クーポン空メッセージ・お気に入り comingsoon を残し、ブランドカード/StaffSnap は本番 live に合わせる
 * - 1.2.0: 期限切れクーポン非表示後、表示件数が0なら空メッセージを出す
 * - 1.1.0: お気に入りモーダルのカートボタンに comingsoon タグ対応を追加
 * - 1.0.0: 既存実装をバージョン管理開始
 */
// https://nozzlegear.com/shopify/using-javascript-to-manage-a-shopify-cart
const CI = {
	create: (tagname = '', args = {}) => {
		return Object.assign(document.createElement(tagname), args)
	},
	clearCart: async () => {
		document.dispatchEvent(new CustomEvent('cart:build'));
		return await (await fetch('/cart/clear.json', { method: 'post', headers: { Accept: 'application/json' } })).json();
	},
	getCart: async () => {
		return await (await fetch('/cart.json')).json();
	},
	addItem: async (items = []) => {
		const param = { method: 'post', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) };
		return await (await fetch('/cart/add.json', param)).json();
	},
	updateCart: async (updates = {}) => {
		const param = { method: 'post', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(updates) };
		return await (await fetch('/cart/update.json', param)).json();
	},
	changeCart: async (changes = {}) => {
		const param = { method: 'post', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(changes) };
		return await (await fetch('/cart/change.json', param)).json();
	},
	now: async () => {
		try {
			const { headers } = await fetch('/cart.js');
			const gmt = [...headers].filter(e => e[0] === 'date');
			return new Date(gmt[0][1]);
		} catch (err) {
			return new Date();
		}
	},
};

const resetButton = () => {
	for (const e of [...document.querySelectorAll('.btn--loading')]) {
		e.classList.remove('btn--loading');
	}
};

window.addEventListener('beforeunload', resetButton);
window.addEventListener('pagehide', resetButton);
window.addEventListener('unload', resetButton);
document.addEventListener('visibilitychange', () => {
	document.visibilityState === 'hidden' && resetButton();
});

document.addEventListener('DOMContentLoaded', () => {
	const videos = document.querySelectorAll('.video-wrapper iframe, .video-wrapper video');
	for (const video of [...videos]) {
		const { clientHeight, clientWidth } = video;

		video.style.aspectRatio = `1 / ${clientHeight / clientWidth}`;
		video.classList.add('loaded');
	}
});

// Amount Purchased
class AmountPurchased {
	total = 0;

	constructor(limit = '', update = 'false', store_sales = 0) {
		const container = document.querySelector('#amount-purchased');
		if (container === null) {
			return;
		}

		if (limit === '') {
			limit = new Date();
			this.limit = new Date(`${limit.getFullYear() + +(limit.getMonth() + 1 >= 3)}-03-01`);
		} else {
			this.limit = new Date(limit);
		}

		this.from = new Date(`${this.limit.getFullYear() - 1}-${this.limit.getMonth() + 1}-${this.limit.getDate()}`);
		this.to = this.limit;

		fetch('/?view=order')
			.then(res => res.json())
			.then(res => {
				const array = [];
				for (const e of res) {
					const { create_at, fulfillment_at, fulfillment_status, financial_status, cancel, tags } = e;
					if (
						fulfillment_at === 'null' ||
						fulfillment_status === 'unfulfilled' ||
						financial_status === 'pending' ||
						cancel === true ||
						tags.includes('店舗売上') ||
						tags.includes('移行データ') 
					) {
						continue;
					}

					// const c_at = new Date(create_at);
					const f_at = new Date(fulfillment_at);

					// if (this.from > c_at || c_at >= this.to || this.from > f_at || f_at >= this.to) {
					if (this.from > f_at || f_at >= this.to) {
						continue;
					}

					array.push(e);
				}
				
				console.table(array);

				for (const { total } of array) {
					this.total += total;
				}
				this.total += store_sales;
				container.innerHTML = this.format(this.total * 100);

				if (update !== 'true') {
					this.insertRank();
				}
			})
			.catch(err => {
				console.error(err);
				container.innerHTML = '集計エラー';
			});
	};

	insertRank() {
		const container = document.querySelector('#rank-msg');
		if (container === null) {
			return;
		}

		container.innerHTML = `${this.to.getFullYear()}年${this.to.getMonth()}月末日までに税込%p以上のご購入で<br class="hide small--show">来年度より <b>%r</b> ステータスです`;

		if (this.total >= 0 && this.total < 30000) {
			container.innerHTML = container.innerHTML.replace('%p', this.format(3000000)).replace('%r', 'ブロンズ');
			return;
		}
		if (this.total >= 30000 && this.total < 60000) {
			container.innerHTML = container.innerHTML.replace('%p', this.format(6000000)).replace('%r', 'シルバー');
			return;
		}
		if (this.total >= 60000 && this.total < 100000) {
			container.innerHTML = container.innerHTML.replace('%p', this.format(10000000)).replace('%r', 'ゴールド');
			return;
		}
		if (this.total >= 100000 && this.total < 200000) {
			container.innerHTML = container.innerHTML.replace('%p', this.format(20000000)).replace('%r', 'ブラック');
			return;
		}

		container.innerHTML = `${this.to.getFullYear()}年${this.to.getMonth()}月末日までに税込¥200,000以上をご購入いただきましたので<br class="hide small--show">来年度より <b>ブラック</b> ステータスです`;
	};

	format(price) {
		return theme.Currency.formatMoney(price, theme.settings.moneyFormat);
	};
};
// Apps: Staff Snap
// class StaffSnap {
// 	host = 'https://api.staff-start.com/v1/coordinate?count=5';

// 	constructor(section) {
// 		const container = section.querySelector(`.staff-snap--container`);

// 		const ID = container.dataset?.merchantId;
// 		if (ID === '') {
// 			section.remove();
// 			return;
// 		}

// 		this.host += `&merchant_id=${ID}`;

// 		const label = container.dataset?.label;
// 		if (label !== '') {
// 			this.host += `&coordinate_label_id=${label}`;
// 		}

// 		Object.assign(this, { section, container});

// 		this.createStaffsnapSection();

// 		Promise.all(['time', 'pv'].map(async mode => await (await fetch(`${this.host}&sort=${mode}`)).json()))
// 			.then(([NEW, RANK]) => {
// 				for (const i in [...NEW.item, ...RANK.item]) {
// 					this.createItems(i, [...NEW.item, ...RANK.item][i]);
// 				}

// 				section.classList.remove('hide');
// 			});
// 	};

// 	createStaffsnapSection() {
// 		const tabs = this.container.querySelectorAll('.snap-tabs a');
// 		this.wrappers = this.container.querySelectorAll('.snap-wrapper');

// 		for (const i in [...tabs]) {
// 			tabs[i].addEventListener('click', e => {
// 				e.preventDefault();

// 				for (const c of [...tabs, ...this.wrappers]) {
// 					c.classList.remove('active');
// 				}

// 				tabs[i].classList.add('active');
// 				this.wrappers[i].classList.add('active');
// 			});
// 		}
// 	};

// 	createItems(i, snap) {
// 		i = +i;
// 		const item = this.container.querySelectorAll('.grid__item')[i];
// 		// if (i > 4) {
// 		// 	item.classList.add('small--hide');
// 		// }

// 		item.querySelector('a').href = `/apps/staffstart/coordinates/${snap.cid}`;
// 		item.querySelector('.snap').src = snap.image_url;
// 		item.querySelector('.grid-product__meta img').src = snap.user_image_url;
// 		item.querySelector('.grid-product__vendor').innerHTML = snap.label_name;
// 		item.querySelector('.name').innerHTML = snap.user_name;
// 		item.querySelector('.height').innerHTML = `${snap.user_height}cm`;
		
// 		if (i > 4) {
// 			item.querySelector('a').append(CI.create('b', { className: 'rank-badge', innerText: i - 4 }));
// 		}
// 	};
// };

// // Staff Start
// document.addEventListener('DOMContentLoaded', () => {
// 	CI.AppsStaffStart = new class AppsStaffStart {
// 		host = 'https://api.staff-start.com/v1';
// 		count = 28;
// 		param = new URLSearchParams(location.search);
// 		path = '/' + location.pathname.split('/').filter(Boolean).join('/');
// 		sort = ['new', 'pv'];

// 		constructor() {
// 			if (this.path === '/apps/staffstart/coordinates') {
// 				location.href = `/pages/coordinates?${this.param.toString()}`;
// 				return;
// 			}
// 			if (this.path === '/apps/staffstart/specificCoordinates') {
// 				location.href = `/pages/specific-coordinates?${this.param.toString()}`;
// 				return;
// 			}
// 			if (this.path === '/apps/staffstart/staffs') {
// 				location.href = `/pages/staffs?${this.param.toString()}`;
// 				return;
// 			}

// 			const container = document.querySelector('#staffstart-shopify-app-container');
// 			if (container === null || this.path.includes('/apps/staffstart/') !== true) {
// 				return;
// 			}

// 			container.classList.add('page-width');

// 			for (const e of container.closest('main.main-content').children) {
// 				if (e.classList.contains('page-width')) {
// 					e.remove();
// 				}
// 			}

// 			const args = { childList: true, subtree: true };
// 			const observer = new MutationObserver(() => {
// 				observer.disconnect();

// 				for (const e of [...container.querySelectorAll('a')]) {
// 					e.after(e.cloneNode(true));
// 					e.remove();
// 				}

// 				const [breadcrumb, contents] = container.childNodes[0].childNodes;

// 				breadcrumb.className = '';
// 				breadcrumb.childNodes[0].className = 'breadcrumb';
// 				for (const e of [...breadcrumb.querySelectorAll('a')]) {
// 					Object.assign(e, { className: '', href: e.href.replace('/apps/staffstart/', '/pages/') });
// 					if (e.href.includes('?') === true) {
// 						e.remove();
// 					}
// 				}

// 				contents.className = '';
// 				contents.childNodes[0].className = '';

// 				if (this.path.includes('/apps/staffstart/coordinates/') === true) {
// 					container.classList.add('apps-coordinates-detail');

// 					const description = container.querySelector('main').childNodes[0].childNodes[0].childNodes[1].childNodes[1].childNodes[0];
// 					if (description !== null && description.querySelectorAll('*').length === 0) {
// 						const parser = new DOMParser().parseFromString(description.innerText, 'text/html');
// 						description.innerHTML = parser.body.innerHTML;
// 					}
// 				}

// 				if (this.path.includes('/apps/staffstart/staffs/') === true) {
// 					container.classList.add('apps-staffs-detail');

// 					const description = container.querySelector('main section:nth-of-type(1)').childNodes[1].childNodes[0];
// 					if (description !== null && description.querySelectorAll('*').length === 0) {
// 						const parser = new DOMParser().parseFromString(description.innerText, 'text/html');
// 						description.innerHTML = parser.body.innerHTML;
// 					}
// 				}

// 				observer.observe(container, args);
// 			});
// 			observer.observe(container, args);
// 		};

// 		async generateCoordinates(container) {
// 			this.host += '/coordinate?';

// 			if (this.param.has('p0') === false || this.param.get('p0') === '') {
// 				this.param.set('p0', '1');
// 			}
// 			if (this.param.has('p1') === false || this.param.get('p1') === '') {
// 				this.param.set('p1', '1');
// 			}
// 			if (this.param.has('sort') === false || this.sort.includes(this.param.get('sort')) === false) {
// 				this.param.set('sort', 'new');
// 			}

// 			history.pushState({}, '', '?' + this.param.toString());

// 			this.initializeFilter(container);

// 			const tabs = container.querySelectorAll('a[data-staff-trigger]');
// 			const contains = container.querySelectorAll('.container[data-staff-trigger]');
// 			const setSort = () => {
// 				for (const e of [...tabs]) {
// 					e.classList.remove('active', 'loaded');

// 					if (e.dataset.staffTrigger === this.param.get('sort')) {
// 						e.classList.add('active');
// 						setTimeout(() => e.classList.add('loaded'), 300);
// 					}
// 				}
// 				for (const e of [...contains]) {
// 					e.classList.add('hide');
// 					if (e.dataset.staffTrigger === this.param.get('sort')) {
// 						e.classList.remove('hide');
// 					}
// 				}
// 			};

// 			setSort();

// 			for (const e of [...tabs]) {
// 				e.addEventListener('click', evt => {
// 					evt.preventDefault();
// 					this.param.set('sort', e.dataset.staffTrigger);
// 					history.pushState({}, '', '?' + this.param.toString());

// 					setSort();
// 				});
// 			}

// 			const param = new URLSearchParams(this.param.toString());
// 			param.set('merchant_id', container.dataset.merchant);
// 			param.set('count', this.count);
// 			param.delete('p0');
// 			param.delete('p1');
// 			param.delete('sort');
// 			if (param.has('productId') === true) {
// 				param.delete('productId');
// 			}

// 			const results = await Promise.all(this.sort.map(async (e, i) => {
// 				param.set('sort', e);
// 				param.set('offset', (this.param.get(`p${i}`) - 1) * this.count);
// 				if (this.param.has('productId') === true && this.param.get('productId') !== '') {
// 					param.set('base_product_code', this.param.get('productId'));
// 				}

// 				return await (await fetch(this.host + param.toString())).json();
// 			}));

// 			for (const i in results) {
// 				const { item, total } = results[i];
// 				const inner = container.querySelectorAll('#result .inner')[i];

// 				if (total === '0') {
// 					inner.innerHTML = '<div class="no-result">条件にマッチするスタッフの情報がありませんでした。</div>';
// 					continue;
// 				}

// 				let rank = param.get('offset') || 0;

// 				for (const { cid, image_url, label_name, user_height, user_image_url, user_id, user_name } of item) {
// 					const e = CI.create('div', { className: 'item' });
// 					const a = CI.create('a', { href: `/apps/staffstart/coordinates/${cid}` });
// 					e.append(a);

// 					const image = CI.create('img', { onload: () => e.classList.add('loaded'), src: image_url });
// 					a.append(image);

// 					e.innerHTML += `
// 						<a href="/apps/staffstart/staffs/${user_id}">
// 							<img src="${user_image_url}">
// 							<div>
// 								<b>${label_name}</b><br>
// 								${user_name}<br>
// 								${user_height}cm
// 							</div>
// 						</a>
// 					`;
// 					inner.append(e);
// 					setTimeout(() => e.classList.add('loaded'), 5000);

// 					if (i > 0) {
// 						rank++;

// 						e.style.position = 'relative';
// 						e.append(CI.create('b', { className: 'grid-product__rank', innerHTML: rank }));
// 					}
// 				}

// 				// Pager
// 				inner.after(this.createPager(total, i));
// 			}
// 		};

// 		async generateStaffs(container) {
// 			this.host += '/staff/list?';

// 			if (this.param.has('p0') === false || this.param.get('p0') === '') {
// 				this.param.set('p0', '1');
// 			}

// 			history.pushState({}, '', '?' + this.param.toString());

// 			this.initializeFilter(container);

// 			const param = new URLSearchParams(this.param.toString());
// 			param.set('merchant_id', container.dataset.merchant);
// 			param.set('count', this.count);
// 			if (param.get('p0') > 1) {
// 				param.set('offset', this.count * param.get('p0'));
// 			}

// 			const { item, total } = await (await fetch(this.host + param.toString())).json();
// 			const inner = container.querySelector('#result .inner');

// 			if (total === '0') {
// 				inner.innerHTML = '<div class="no-result">条件にマッチするスタッフの情報がありませんでした。</div>';
// 				return;
// 			}

// 			for (const { name, height, img, label_name, user_id } of item) {
// 				const e = CI.create('div', { className: 'item' });
// 				const a = CI.create('a', { href: `/apps/staffstart/staffs/${user_id}` });
// 				e.append(a);

// 				const image = CI.create('img', { onload: () => e.classList.add('loaded'), src: img });
// 				a.append(image);

// 				a.innerHTML += `
// 					<div class="text-center">
// 						<b>${name}　${height}cm</b><br>
// 						${label_name}
// 					</div>
// 				`;
// 				inner.append(e);
// 				setTimeout(() => e.classList.add('loaded'), 5000);
// 			}

// 			// Pager
// 			inner.after(this.createPager(total));
// 		};

// 		initializeFilter(container) {
// 			for (const form of [...container.querySelectorAll('form')]) {
// 				for (const e of [...form.querySelectorAll('[name="gender"], [name="coordinate_genre"]')]) {
// 					if (this.param.has(e.name) === false) {
// 						continue;
// 					}

// 					if (e.nodeName === 'INPUT' && this.param.get(e.name) === e.value) {
// 						e.checked = true;
// 					}
// 					if (e.nodeName === 'SELECT') {
// 						e.querySelector(`[value="${this.param.get(e.name)}"]`).selected = true;
// 					}
// 				}

// 				if (this.param.has('from_height') === true && this.param.has('to_height') === true) {
// 					const height = [this.param.get('from_height'), this.param.get('to_height')].join();
// 					form.querySelector(`[name="height"] option[value="${height}"]`).selected = true;
// 				}

// 				for (const e of [...form.querySelectorAll('[name="coordinate_label_id"]')]) {
// 					if (this.param.has('coordinate_label_id') === false) {
// 						continue;
// 					}

// 					if (e.nodeName === 'INPUT' && this.param.get('coordinate_label_id') === e.value) {
// 						e.checked = true;
// 					}
// 					if (e.nodeName === 'SELECT') {
// 						e.querySelector(`[value="${this.param.get('coordinate_label_id')}"]`).selected = true;
// 					}
// 				};

// 				form.addEventListener('change', () => {
// 					const formdate = new FormData(form);
// 					const param = new URLSearchParams();

// 					if (formdate.has('gender') === true && formdate.get('gender') !== '') {
// 						param.append('gender', formdate.get('gender'));
// 					}
// 					if (formdate.has('coordinate_genre') === true && formdate.get('coordinate_genre') !== '') {
// 						param.append('coordinate_genre', formdate.get('coordinate_genre'));
// 					}

// 					if (this.param.has('productId') === true) {
// 						param.set('productId', this.param.get('productId'));
// 					}

// 					if (formdate.get('height') !== '') {
// 						const [fromHeight, toHeight] = formdate.get('height').split(',');
// 						param.set('from_height', fromHeight);
// 						param.set('to_height', toHeight);
// 					}

// 					if (formdate.has('coordinate_label_id') === true && formdate.get('coordinate_label_id') !== '') {
// 						param.set('coordinate_label_id', formdate.get('coordinate_label_id'));
// 					}

// 					location.href = location.pathname + '?' + param.toString();
// 				});
// 			}
// 		};

// 		createPager(total, p = 0) {
// 			total = +total;

// 			const pagination = CI.create('div', { className: 'pagination' });
// 			const paged = +this.param.get(`p${p}`);
// 			const pages = Math.ceil(total / this.count) - 1;

// 			let offset = [-2, -1, 0, 1, 2].map(n => n + paged);
// 			for (const n of [...offset]) {
// 				0 >= n && offset.push([...offset].reverse()[0] + 1);
// 			}
// 			for (const n of [...offset]) {
// 				n > pages && offset.unshift([...offset][0] - 1);
// 			}
// 			offset = offset.sort().filter(Boolean).filter(n => {
// 				return n > 0 && pages >= n;
// 			});

// 			for (const n of offset) {
// 				const pager = CI.create('span', { className: 'page' });
// 				pagination.append(pager);

// 				if (paged === n) {
// 					pager.classList.add('current');
// 					pager.innerHTML = n;
// 					continue;
// 				}

// 				const param = new URLSearchParams(location.search);
// 				param.set(`p${p}`, n);
// 				if (param.has('sort') === true) {
// 					param.set('sort', this.sort[p]);
// 				}

// 				pager.append(CI.create('a', { href: `${location.pathname}?${param.toString()}`, innerHTML: n }));
// 			}

// 			// Prev
// 			if (paged > 1) {
// 				const param = new URLSearchParams(location.search);
// 				param.set(`p${p}`, paged - 1);
// 				if (param.has('sort') === true) {
// 					param.set('sort', this.sort[p]);
// 				}

// 				pagination.prepend(CI.create('span', {
// 					className: 'prev',
// 					innerHTML: `
// 						<a href="${location.pathname}?${param.toString()}">
// 							<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>
// 						</a>
// 					` })
// 				);
// 			}

// 			// First
// 			if (paged > 1) {
// 				// pagination.prepend(CI.create('span', { className: 'page', innerHTML: '…' }));

// 				// if (param.has('sort') !== true) {
// 				// 	param.set('p', 1);
// 				// }
// 				// if (param.has('sort') === true && coordinates !== null) {
// 				// 	param.set('sort', coordinates == 0 ? 'new' : 'pv');

// 				// 	const n = param.get('p').split('_');
// 				// 	n[coordinates] = 1;
// 				// 	param.set('p', n.join('_'));
// 				// }
// 				// pagination.prepend(CI.create('span', { className: 'page', innerHTML: `<a href="${location.pathname}?${param.toString()}">1</a>` }));
// 			}

// 			// Next
// 			if (pages > paged) {
// 				const param = new URLSearchParams(location.search);
// 				param.set(`p${p}`, paged + 1);
// 				if (param.has('sort') === true) {
// 					param.set('sort', this.sort[p]);
// 				}

// 				pagination.append(CI.create('span', {
// 					className: 'next',
// 					innerHTML: `
// 						<a href="${location.pathname}?${param.toString()}">
// 							<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>
// 						</a>
// 					`})
// 				);
// 			}

// 			// Last
// 			if (paged < pages) {
// 				// pagination.append(CI.create('span', { className: 'page', innerHTML: '…' }));

// 				// if (param.has('sort') !== true) {
// 				// 	param.set('p', pages);
// 				// }
// 				// if (param.has('sort') === true && coordinates !== null) {
// 				// 	param.set('sort', coordinates == 0 ? 'new' : 'pv');

// 				// 	const n = param.get('p').split('_');
// 				// 	n[coordinates] = pages;
// 				// 	param.set('p', n.join('_'));
// 				// }
// 				// pagination.append(CI.create('span', { className: 'page', innerHTML: `<a href="${location.pathname}?${param.toString()}">${pages}</a>` }));
// 			}

// 			return pagination;
// 		};
// 	};
// });

// Apps: WishList - 旧実装 (Swym Relay) は無効化、参考保持
/*
document.addEventListener('DOMContentLoaded', () => {
	CI.WishList = new class WishList {
		render() {
			const target = document.querySelector('#wishlist-list');
			if (target === null) {
				return;
			}

			const initialize = async swat => {
				await swat.fetch(products => {
					target.innerHTML = '';

					if (products.length === 0) {
						target.innerHTML = CI.string.wishlist.no_result;
						return;
					}

					const wrapper = CI.create('div', { className: 'grid--list fv-grid', style: '--template-columns:repeat(4,1fr);--template-columns-sp:repeat(3, 1fr);' });
					target.append(wrapper);

					for (const { du, iu, dt, vi, pr, epi, empi } of products) {
						let available = false;
						let cartButton = "";
						// Cart Add button
						fetch(du+".js")
						.then(res => res.json())
						.then(product => {
							const variant = product.variants.find(v => v.id === epi);
							const tgt = document.querySelector(`[data-sku="${epi}"]`);
							const comingsoonTag = product.tags.find(tag => tag.startsWith("comingsoon:"));
							if (comingsoonTag) {
								const dateStr = comingsoonTag.replace("comingsoon:", "").replace("_"," "); 
								tgt.classList.remove("btn--loading");
								tgt.classList.add("disabled");
								tgt.disabled = true;
								tgt.href = "#";
								tgt.innerHTML = dateStr + " 発売予定";
							} else if (variant && variant.available) {
								//available
								available = true;
								tgt.classList.remove("btn--loading");
							} else {
								//sold out
								tgt.classList.remove("btn--loading");
								tgt.classList.add("disabled");
								tgt.disabled = true;
								tgt.href = "#";
								tgt.innerHTML = "SOLD OUT";
							}
							document.addEventListener('click', e => {
								const btn = e.target.closest('.fv_cartBtn:not(.disabled)');
								if (!btn) return;
								if (btn.classList.contains('btn--loading')) return; // 二重防止
								fvAddToCart(btn.dataset.sku, 1, btn);
							});
						});
						const innerHTML = `
							<div class="image">
								<a href="${du}"><img src="${iu}"></a>
								<button type="button" id="removeFavorite" class="removeFavoriteBtn __remove">
									<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>
									<span class="icon__fallback-text">"閉じる"</span>
								</button>
							</div>
							<div class="">
								<a href="${du}"><b style="font-size: 14px;">${dt}</b></a>
							</div>
							<div class="price text-center">
								<a href="${du}">${vi}</a>
								<a href="${du}"><b>¥${pr.toLocaleString()}</b></a>
							</div>
							<button data-sku="${epi}" class="fv_cartBtn btn btn--small btn--loading">カートに入れる</button>
							`;

						const item = CI.create('div', { className: 'grid--list-item fv-grid-product', innerHTML });
						wrapper.append(item);

						item.querySelector('.__remove').addEventListener('click', e => {
							e.preventDefault();

							window._swat.fetch(ps => {
								for (const p of ps) {
									if (epi&& epi == p.epi && empi  && empi == p.empi) {
										window._swat.removeFromWishList(p, () => {
											if (!window.SwymCallbacks) {
												window.SwymCallbacks = [];
											}
											window.SwymCallbacks.push(initialize);
										});
									}
								}
							});
						});
					}
				});
			};

			if (!window.SwymCallbacks) {
				window.SwymCallbacks = [];
			}
			window.SwymCallbacks.push(initialize);
		};
	};
});
*/

// Apps: WishList - Calif multilikes 版 (PRODUCT / BRAND 独立 panel)
document.addEventListener('DOMContentLoaded', () => {
	CI.WishList = new class WishList {
		constructor() {
			this.limit = 48;
			this.productTarget = null;
			this.brandTarget = null;
			this.config = null;
			this.renderId = 0;
			this.tabs = this.createTabStates();
		}

		render() {
			this.productTarget = document.querySelector('#wishlist-product-list');
			this.brandTarget = document.querySelector('#wishlist-brand-list');

			if (this.productTarget === null && this.brandTarget === null) {
				return;
			}

			this.config = this.resolveConfig();
			this.renderId += 1;
			this.tabs = this.createTabStates();

			if (this.productTarget) {
				this.renderPanel('product');
			}
			if (this.brandTarget) {
				this.renderPanel('brand');
			}

			if (this.canFetchTab()) {
				if (this.productTarget) {
					this.fetchWishlistPage('product');
				}
				if (this.brandTarget) {
					this.fetchWishlistPage('brand');
				}
			}
		}

		createTabStates() {
			return {
				product: this.createTabState('product'),
				brand: this.createTabState('brand'),
			};
		}

		createTabState(key) {
			return {
				key,
				items: [],
				pageInfo: null,
				total: 0,
				loading: false,
				initialized: false,
				error: null,
				requestId: 0,
			};
		}

		getPanel(tabKey) {
			return tabKey === 'brand' ? this.brandTarget : this.productTarget;
		}

		resolveConfig() {
			const config = window.multilikesProductConfig || {};
			const customerId =
				config.customerId ||
				document.querySelector('#customerId')?.dataset?.customerId ||
				'';

			return {
				defaultUrl: config.defaultUrl || '',
				customerId,
				texts: config.texts || {},
			};
		}

		resolveText(keys, fallback) {
			const candidates = Array.isArray(keys) ? keys : [keys];
			for (const key of candidates) {
				const value = this.config?.texts?.[key];
				if (typeof value === 'string' && value !== '') {
					return value;
				}
			}
			return fallback;
		}

		getTexts() {
			return {
				loading: this.resolveText(['loading', 'loadingText', 'loading_text'], CI.string.wishlist.loading || '読込中..'),
				error: this.resolveText(
					['error', 'errorText', 'error_text'],
					CI.string.wishlist.error || 'お気に入り一覧の読み込み中にエラーが発生しました。<br>再読み込みを行い、再度お試し下さい。'
				),
				empty: this.resolveText(['empty', 'emptyText', 'empty_text'], CI.string.wishlist.no_result || '<p class="text-center">お気に入りがありません</p>'),
				loginRequired: this.resolveText(
					['loginRequired', 'loginRequiredText', 'login_required_text'],
					CI.string.wishlist.login_required || 'お気に入り機能を使用するにはログインが必要です'
				),
				loginLabel: CI.string.wishlist.login || 'ログイン・新規メンバー登録',
				deleted: this.resolveText(['deleted', 'deletedText', 'deleted_text'], CI.string.wishlist.deleted || '削除'),
				loadMore: this.resolveText(['loadMore', 'loadMoreText', 'load_more_text'], CI.string.wishlist.load_more || 'もっと見る'),
				addToCart: this.resolveText(['addToCart', 'addToCartText', 'add_to_cart_text'], CI.string.wishlist.add_to_cart || 'カートへ入れる'),
				soldOut: this.resolveText(['soldOut', 'soldOutText', 'sold_out_text'], CI.string.wishlist.sold_out || 'SOLD OUT'),
			};
		}

		canFetchTab() {
			return Boolean(this.config?.defaultUrl && this.config?.customerId);
		}

		getTabState(tabKey) {
			return this.tabs[tabKey];
		}

		createTextMessage(text) {
			return CI.create('p', { className: 'text-center', textContent: text });
		}

		createHtmlMessage(html) {
			const wrap = CI.create('div', { className: 'text-center' });
			wrap.innerHTML = html;
			return wrap;
		}

		createLoginRequiredContent() {
			const wrap = CI.create('div', { className: 'text-center' });
			const message = CI.create('p', { textContent: this.getTexts().loginRequired });
			const actionWrap = CI.create('p');
			const action = CI.create('a', {
				className: 'text--link',
				href: `/account/login?return_url=${encodeURIComponent(window.location.href)}`,
				textContent: this.getTexts().loginLabel,
			});

			actionWrap.append(action);
			wrap.append(message, actionWrap);

			return wrap;
		}

		renderPanel(tabKey) {
			const panel = this.getPanel(tabKey);
			if (panel === null) {
				return;
			}

			panel.innerHTML = '';

			if (!this.config?.defaultUrl) {
				panel.append(this.createHtmlMessage(this.getTexts().error));
				return;
			}

			if (!this.config?.customerId) {
				panel.append(this.createLoginRequiredContent());
				return;
			}

			const state = this.getTabState(tabKey);
			if (state.error) {
				panel.append(this.createHtmlMessage(this.getTexts().error));
				return;
			}

			if (!state.initialized) {
				panel.append(this.createTextMessage(this.getTexts().loading));
				return;
			}

			if (state.items.length === 0) {
				panel.append(this.createHtmlMessage(this.getTexts().empty));
				return;
			}

			const grid = CI.create('div', { className: 'grid grid--uniform' });
			state.items.forEach(item => {
				grid.append(this.createWishlistItem(state.key, item));
			});

			const loadMoreWrap = CI.create('p', { className: 'text-center' });
			const loadMoreButton = this.createLoadMoreButton(state);
			if (loadMoreButton) {
				loadMoreWrap.append(loadMoreButton);
			}

			panel.append(grid, loadMoreWrap);
		}

		createLoadMoreButton(state) {
			const hasNextPage = Boolean(state.pageInfo?.hasNextPage && state.pageInfo?.endCursor);
			if (!hasNextPage) {
				return null;
			}

			const button = CI.create('button', {
				type: 'button',
				className: 'btn btn--large section-more__link',
				textContent: this.getTexts().loadMore,
			});
			button.disabled = state.loading;
			button.addEventListener('click', () => {
				this.fetchWishlistPage(state.key, state.pageInfo?.endCursor || '');
			});

			return button;
		}

		buildWishlistParams(tabKey, after = '') {
			const params = new URLSearchParams({
				mode: 'customer_wishlist',
				customer_id: this.config.customerId,
				limit: String(this.limit),
			});

			if (tabKey === 'brand') {
				params.set('metaobject_type', 'multilikes_brand');
			} else {
				params.set('target_type', 'product');
			}

			if (after) {
				params.set('after', after);
			}

			return params;
		}

		async fetchWishlistPage(tabKey, after = '') {
			const state = this.getTabState(tabKey);
			if (!state || state.loading || !this.canFetchTab()) {
				return;
			}

			const currentRenderId = this.renderId;
			state.requestId += 1;
			const currentRequestId = state.requestId;
			state.loading = true;
			state.error = null;

			this.renderPanel(tabKey);

			try {
				const params = this.buildWishlistParams(tabKey, after);
				const response = await fetch(`${this.config.defaultUrl}?${params.toString()}`, {
					method: 'GET',
					headers: {
						Accept: 'application/json',
					},
				});
				const result = await response.json();

				if (currentRenderId !== this.renderId || currentRequestId !== state.requestId) {
					return;
				}

				if (!response.ok || result?.error) {
					throw new Error(result?.error || 'wishlist fetch failed');
				}

				const items = Array.isArray(result?.data) ? result.data : [];
				state.items = after ? state.items.concat(items) : items;
				state.pageInfo = result?.pageInfo || null;
				state.total = typeof result?.total === 'number' ? result.total : state.total;
				state.initialized = true;
				state.error = null;
			} catch (error) {
				if (currentRenderId !== this.renderId || currentRequestId !== state.requestId) {
					return;
				}

				console.error('Error fetching wishlist:', error);
				state.items = [];
				state.pageInfo = null;
				state.total = 0;
				state.initialized = true;
				state.error = error;
			} finally {
				if (currentRenderId === this.renderId && currentRequestId === state.requestId) {
					state.loading = false;
					this.renderPanel(tabKey);
				}
			}
		}

		createWishlistItem(tabKey, item) {
			if (tabKey === 'brand') {
				return this.createBrandWishlistItem(item);
			}

			return this.createProductWishlistItem(item);
		}

		createWishlistCardWrapper(url = '') {
			if (url) {
				return CI.create('a', {
					className: 'c-wishlist-modal-card-link',
					href: url,
				});
			}

			return CI.create('div', { className: 'c-wishlist-modal-card-body' });
		}

		appendCardImage(container, imageUrl, altText) {
			if (!imageUrl) {
				return;
			}

			const image = CI.create('img', {
				src: imageUrl,
				loading: 'lazy',
				alt: altText || '',
			});
			container.append(image);
		}

		createCardTitle(titleText, secondaryText = '') {
			const title = CI.create('div', { className: 'grid-product__title grid-product__title--body' });
			const titleStrong = CI.create('b', { textContent: titleText || '' });
			titleStrong.style.fontSize = '14px';
			title.append(titleStrong);

			if (secondaryText) {
				title.append(document.createElement('br'));
				title.append(document.createTextNode(secondaryText));
			}

			return title;
		}

		createRemoveButton(onClick) {
			const removeButton = CI.create('a', {
				className: 'text--link __remove c-wishlist-modal-remove',
				href: '#',
				textContent: '×',
				title: this.getTexts().deleted,
			});
			removeButton.setAttribute('aria-label', this.getTexts().deleted);
			removeButton.addEventListener('click', event => {
				event.preventDefault();
				onClick(removeButton);
			});

			return removeButton;
		}

		normalizeProductTags(tags) {
			if (Array.isArray(tags)) {
				return tags.map(tag => String(tag).trim()).filter(Boolean);
			}
			if (typeof tags === 'string' && tags !== '') {
				return tags.split(',').map(tag => tag.trim()).filter(Boolean);
			}
			return [];
		}

		resolveComingSoonLabel(tags) {
			const comingsoonTag = this.normalizeProductTags(tags).find(tag => tag.startsWith('comingsoon:'));
			if (!comingsoonTag) {
				return '';
			}

			const dateStr = comingsoonTag.replace('comingsoon:', '').replace('_', ' ');
			return `${dateStr} 発売予定`;
		}

		applyComingSoonToCartButton(product, cartButton) {
			if (!product?.productHandle || !cartButton) {
				return;
			}

			fetch(`/products/${product.productHandle}.js`)
				.then(response => {
					if (!response.ok) {
						throw new Error(`product fetch failed: ${response.status}`);
					}
					return response.json();
				})
				.then(productJson => {
					const comingSoonLabel = this.resolveComingSoonLabel(productJson?.tags);
					if (!comingSoonLabel) {
						return;
					}

					cartButton.disabled = true;
					cartButton.textContent = comingSoonLabel;
				})
				.catch(error => {
					console.error('Error checking comingsoon tag for wishlist item:', error);
				});
		}

		createProductWishlistItem(product) {
			const item = CI.create('div', {
				className: 'grid__item grid-product medium-up--one-quarter small--one-half',
			});
			item.dataset.variantId = product.id || '';
			item.dataset.productId = product.productId || '';

			const content = CI.create('div', { className: 'grid-product__content' });
			const productUrl = product.productHandle ? `/products/${product.productHandle}?variant=${product.id}` : '';
			const link = this.createWishlistCardWrapper(productUrl);
			this.appendCardImage(
				link,
				product.image,
				product.variantTitle ? `${product.title} ${product.variantTitle}` : product.title || ''
			);

			const meta = CI.create('div', { className: 'grid-product__meta' });
			const title = this.createCardTitle(product.title || '', product.variantTitle || '');
			const price = CI.create('div', { className: 'grid-product__price' });
			price.append(CI.create('b', { textContent: product.price || '' }));

			meta.append(title, price);
			link.append(meta);
			content.append(link);

			const removeButton = this.createRemoveButton(trigger => {
				this.removeProductWishlistItem(product, trigger);
			});
			const cartButton = CI.create('button', {
				type: 'button',
				className: 'btn btn--primary btn--full',
				textContent: product.available === true ? this.getTexts().addToCart : this.getTexts().soldOut,
			});
			if (product.available !== true) {
				cartButton.disabled = true;
			} else {
				cartButton.addEventListener('click', () => {
					if (cartButton.disabled) {
						return;
					}
					this.addWishlistItemToCart(product, cartButton);
				});
			}

			this.applyComingSoonToCartButton(product, cartButton);

			content.append(removeButton, cartButton);
			item.append(content);

			return item;
		}

		createBrandWishlistItem(brand) {
			const item = CI.create('div', {
				className: 'grid__item grid-product medium-up--one-quarter small--one-half',
			});
			item.dataset.metaobjectId = brand.id || '';

			const content = CI.create('div', { className: 'grid-product__content' });
			const detailUrl = this.resolveMetaobjectField(brand, 'detail_url');
			const titleText =
				brand.displayName ||
				this.resolveMetaobjectField(brand, 'name') ||
				brand.handle ||
				'';
			const imageUrl =
				this.resolveMetaobjectField(brand, 'logo') ||
				this.resolveMetaobjectField(brand, 'image');

			const body = this.createWishlistCardWrapper(detailUrl);
			this.appendCardImage(body, imageUrl, titleText);

			if (!imageUrl) {
				const meta = CI.create('div', { className: 'grid-product__meta' });
				meta.append(this.createCardTitle(titleText));
				body.append(meta);
			}

			const removeButton = this.createRemoveButton(trigger => {
				this.removeBrandWishlistItem(brand, trigger);
			});

			content.append(removeButton, body);
			item.append(content);

			return item;
		}

		resolveMetaobjectField(item, key) {
			if (!Array.isArray(item?.fields)) {
				return '';
			}

			const field = item.fields.find(entry => entry?.key === key);
			if (!field) {
				return '';
			}

			const value = field.value ?? field.jsonValue ?? '';
			if (typeof value === 'string') {
				return value;
			}

			if (value && typeof value === 'object') {
				if (typeof value.url === 'string') {
					return value.url;
				}
				if (typeof value.src === 'string') {
					return value.src;
				}
			}

			return '';
		}

		async addWishlistItemToCart(product, trigger) {
			if (!product?.id) {
				return;
			}

			trigger.disabled = true;

			try {
				const cart = await CI.addItem([{ id: product.id, quantity: 1 }]);
				if (cart?.status && cart?.description) {
					throw new Error(cart.description);
				}
				document.dispatchEvent(new CustomEvent('cart:build'));
				window.location.href = '/cart';
			} catch (error) {
				console.error('Error adding wishlist item to cart:', error);
				alert(error?.message || 'カートへの追加に失敗しました。');
			} finally {
				trigger.disabled = false;
			}
		}

		async removeProductWishlistItem(product, trigger) {
			if (!this.config.defaultUrl || !this.config.customerId) {
				return;
			}

			const state = this.getTabState('product');
			trigger.style.pointerEvents = 'none';
			trigger.setAttribute('aria-disabled', 'true');

			try {
				const response = await fetch(this.config.defaultUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						Accept: 'application/json',
					},
					body: new URLSearchParams({
						target_type: 'product',
						customer_id: this.config.customerId,
						action: 'remove',
						product_id: product.productId,
						variant_id: product.id,
					}),
				});
				const result = await response.json();

				if (!response.ok || result?.error || result?.data?.success !== true) {
					throw new Error(result?.error || 'wishlist remove failed');
				}

				state.items = state.items.filter(({ id }) => String(id) !== String(product.id));
				this.syncProductButtons(product.id, result?.data?.favoriteCount);

				this.renderPanel('product');
			} catch (error) {
				console.error('Error removing wishlist item:', error);
				state.items = [];
				state.pageInfo = null;
				state.total = 0;
				state.initialized = true;
				state.error = error;
				this.renderPanel('product');
			} finally {
				trigger.style.pointerEvents = '';
				trigger.removeAttribute('aria-disabled');
			}
		}

		async removeBrandWishlistItem(brand, trigger) {
			if (!this.config.defaultUrl || !this.config.customerId) {
				return;
			}

			const state = this.getTabState('brand');
			trigger.style.pointerEvents = 'none';
			trigger.setAttribute('aria-disabled', 'true');

			try {
				const response = await fetch(this.config.defaultUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						Accept: 'application/json',
					},
					body: new URLSearchParams({
						target_type: 'metaobject',
						metaobject_type: 'multilikes_brand',
						metaobject_id: brand.id,
						customer_id: this.config.customerId,
						action: 'remove',
					}),
				});
				const result = await response.json();

				if (!response.ok || result?.error || result?.data?.success !== true) {
					throw new Error(result?.error || 'brand wishlist remove failed');
				}

				state.items = state.items.filter(({ id }) => String(id) !== String(brand.id));
				this.syncBrandButtons(brand.id, result?.data?.favoriteCount);

				document.dispatchEvent(new CustomEvent('ci:favorite-brand:changed', {
					detail: {
						metaobjectId: String(brand.id),
						isInWishlist: false,
						favoriteCount: typeof result?.data?.favoriteCount === 'number' ? result.data.favoriteCount : null,
					},
				}));

				this.renderPanel('brand');
			} catch (error) {
				console.error('Error removing brand wishlist item:', error);
				state.items = [];
				state.pageInfo = null;
				state.total = 0;
				state.initialized = true;
				state.error = error;
				this.renderPanel('brand');
			} finally {
				trigger.style.pointerEvents = '';
				trigger.removeAttribute('aria-disabled');
			}
		}

		syncProductButtons(variantId, favoriteCount) {
			const buttons = document.querySelectorAll('[data-custom-multilikes-product-button]');
			buttons.forEach(button => {
				if (String(button.dataset.variantId) !== String(variantId)) {
					return;
				}

				if (button._wishlistButtonInstance) {
					button._wishlistButtonInstance.updateButtonState(false, favoriteCount);
					return;
				}

				button.dataset.isInWishlist = 'false';
				button.classList.remove('is-active');
			});
		}

		syncBrandButtons(metaobjectId, favoriteCount) {
			const normalizedId = String(metaobjectId);
			const resolvedCount = typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount) ? favoriteCount : 0;

			const productBrandButtons = document.querySelectorAll('[data-custom-multilikes-product-brand-button]');
			productBrandButtons.forEach(button => {
				const buttonMetaobjectId =
					button._brandWishlistButtonInstance?.metaobjectId ||
					button.dataset.metaobjectId ||
					'';

				if (String(buttonMetaobjectId) !== normalizedId) {
					return;
				}

				if (button._brandWishlistButtonInstance) {
					button._brandWishlistButtonInstance.updateButtonState(false, resolvedCount);
					return;
				}

				button.dataset.isInWishlist = 'false';
				button.classList.remove('is-active');
			});

			const brandButtons = document.querySelectorAll('.brand_wishlist_button[data-object-type][data-object-id]');
			brandButtons.forEach(button => {
				if (String(button.dataset.objectId) !== normalizedId) {
					return;
				}

				if (button._brandWishlistListInstance) {
					button._brandWishlistListInstance.syncState(false, resolvedCount);
					return;
				}

				button.dataset.isInWishlist = 'false';
				button.classList.remove('is-active', 'remove-favorite');
				button.classList.add('add-favorite');
			});

			const countElements = document.querySelectorAll('.brand-favorites-count[data-object-id]');
			countElements.forEach(element => {
				if (String(element.dataset.objectId) !== normalizedId) {
					return;
				}

				element.textContent = String(resolvedCount);
			});
		}
	};
});

// Specify Delivery Date
class SpecifyDeliveryDate {
	date = null;
	time = null;
	week = CI.string.cart.shipping.week.split(',');

	constructor(now = new Date()) {
		this.date = document.querySelector('#attributes-shipping-date');
		this.time = document.querySelector('#attributes-shipping-date-time');

		if (this.date === null && this.time == null) {
			return;
		}

		const { dataset } = this.date;
		const disable = { days: dataset.disableDay !== '' ? dataset.disableDay.split(',') : [], week: dataset.disableWeek };
		const enable = dataset.enable !== '' ? dataset.enable.split(',') : [];
		const limit = +dataset.limit;
		const offset = dataset.offset > 0 ? dataset.offset - 1 : dataset.offset;

		let i = 0;
		for (const n of [...Array(100).keys()].map(i => i + offset)) {
			if (i >= limit - offset) {
				break;
			}
			const d = new Date(now);
			d.setDate(d.getDate() + n);

			const str = d.getFullYear() + '/' + `0${d.getMonth() + 1}`.slice(-2) + '/' + `0${d.getDate()}`.slice(-2);
			if (disable.days.includes(str) || disable.week.includes(this.week[d.getDay()])) {
				if (enable.includes(str) !== true) {
					continue;
				}
			}

			const option = CI.create('option', { innerHTML: str + `（${this.week[d.getDay()]}）`, value: str });
			if (dataset.selected === str) {
				option.selected = true;
			}
			this.date.append(option);

			i++;
		}

		if (this.time.dataset.select !== '') {
			this.time.querySelector(`option[value="${this.time.dataset.select}"]`).selected = true;
		}
	};

	checkout( now) {
		const DATE = CI.string.cart.shipping.date;
		const TIME = CI.string.cart.shipping.time;

		const attributes = {};
		attributes[DATE] = null;
		attributes[TIME] = null;

		if (this.date === null && this.time == null) {
			return attributes;
		}

		if (this.date !== null && this.date.value !== '' && now > new Date(this.date.value)) {
			alert('有効な配送指定日が超過されているため、配送日を再度設定されてください。');
			return true;
		}

		if (this.date.value !== '') {
			attributes[DATE] = this.date.value;
		}
		if (this.time.value !== '') {
			attributes[TIME] = this.time.value;
		}

		return attributes;
	};
};

// Append Province
class AppendProvince {
	prefs = [
		{ p: "北海道", v: "Hokkaidō" },
		{ p: "青森県", v: "Aomori" },
		{ p: "岩手県", v: "Iwate" },
		{ p: "宮城県", v: "Miyagi" },
		{ p: "秋田県", v: "Akita" },
		{ p: "山形県", v: "Yamagata" },
		{ p: "福島県", v: "Fukushima" },
		{ p: "茨城県", v: "Ibaraki" },
		{ p: "栃木県", v: "Tochigi" },
		{ p: "群馬県", v: "Gunma" },
		{ p: "埼玉県", v: "Saitama" },
		{ p: "千葉県", v: "Chiba" },
		{ p: "東京都", v: "Tōkyō" },
		{ p: "神奈川県", v: "Kanagawa" },
		{ p: "新潟県", v: "Niigata" },
		{ p: "富山県", v: "Toyama" },
		{ p: "石川県", v: "Ishikawa" },
		{ p: "福井県", v: "Fukui" },
		{ p: "山梨県", v: "Yamanashi" },
		{ p: "長野県", v: "Nagano" },
		{ p: "岐阜県", v: "Gifu" },
		{ p: "静岡県", v: "Shizuoka" },
		{ p: "愛知県", v: "Aichi" },
		{ p: "三重県", v: "Mie" },
		{ p: "滋賀県", v: "Shiga" },
		{ p: "京都府", v: "Kyōto" },
		{ p: "大阪府", v: "Ōsaka" },
		{ p: "兵庫県", v: "Hyōgo" },
		{ p: "奈良県", v: "Nara" },
		{ p: "和歌山県", v: "Wakayama" },
		{ p: "鳥取県", v: "Tottori" },
		{ p: "島根県", v: "Shimane" },
		{ p: "岡山県", v: "Okayama" },
		{ p: "広島県", v: "Hiroshima" },
		{ p: "山口県", v: "Yamaguchi" },
		{ p: "徳島県", v: "Tokushima" },
		{ p: "香川県", v: "Kagawa" },
		{ p: "愛媛県", v: "Ehime" },
		{ p: "高知県", v: "Kōchi" },
		{ p: "福岡県", v: "Fukuoka" },
		{ p: "佐賀県", v: "Saga" },
		{ p: "長崎県", v: "Nagasaki" },
		{ p: "熊本県", v: "Kumamoto" },
		{ p: "大分県", v: "Ōita" },
		{ p: "宮崎県", v: "Miyazaki" },
		{ p: "鹿児島県", v: "Kagoshima" },
		{ p: "沖縄県", v: "Okinawa" }
	];

	constructor(form) {
		const province = form.querySelector('[name*="province"]');
		const selected = province.dataset?.selected;

		for (const { p, v } of this.prefs) {
			const option = CI.create('option', { innerHTML: p, value: v });
			if (selected !== '' && p === selected) {
				option.selected = true;
			}
			province.append(option);
		}
	};
};

// General: Brand list
document.addEventListener('DOMContentLoaded', () => {
	CI.BrandList = new class BrandList {
		constructor() {
			const container = document.querySelector('.brand-list');
			if (container.querySelectorAll('li').length > 1) {
				const ul = container.querySelector('ul');
				const prev = container.querySelector('.brand-list--prev');
				const next = container.querySelector('.brand-list--next');

				const toggleClass = (buffer = 0) => {
					const start = ul.scrollLeft;
					const end = ul.scrollWidth - ul.clientWidth - start + buffer;

					if (start > 0) prev.classList.remove('hide');
					if (start === 0) prev.classList.add('hide');
					if (end > 0) next.classList.remove('hide');
					if (end === 0) next.classList.add('hide');
				};

				toggleClass(1);
				ul.addEventListener('scroll', () => toggleClass());

				prev.addEventListener('click', () => {
					const left = ul.scrollLeft - ul.clientWidth / 6;
					ul.scroll({ left, behavior: 'smooth' });
				});
				next.addEventListener('click', () => {
					const left = ul.scrollLeft + ul.clientWidth / 6;
					ul.scroll({ left, behavior: 'smooth' });
				});
			}
		};
	};
});

// General: Cart In Novelty
class CartInNovelty {
	novelties = {};

	constructor(form) {
		this.form = form;
	};

	async submit() {
		try {
			const param = new URLSearchParams(location.search);
			param.set('view', 'novelty');
			const res = await (await fetch(`${location.pathname}?${param.toString()}`)).json();

			for (const [code, { id }] of Object.entries(res)) {
				if (id !== null) {
					this.form.append(CI.create('input', { name: 'properties[ノベルティ対象商品]', type: 'hidden', value: code }));
					break;
				}
			}
		} catch (err) {
			console.error(err)
		}
	};

	async update({ items }) {
		this.changes = [];
		this.error = [];

		this.container = document.querySelector('#cart-novelty');
		this.container.classList.add('hide');

		this.msg = this.container.querySelector('.err_msg');
		this.msg = Object.assign(this.msg, { className: 'err_msg hide', innerHTML: '' });

		const novelties = this.container.querySelectorAll('.novelty--item');
		const in_cart = {};
		for (const novelty of [...novelties]) {
			novelty.classList.add('hide');

			const { code, id, stock, min } = novelty.dataset; /* start, end, */
			const checkbox = Object.assign(novelty.querySelector('input[type="checkbox"]'), { checked: false });

			in_cart.novelty = items.filter(({ properties }) => {
				return properties['ノベルティ商品'] != undefined && properties['ノベルティ商品'] == code;
			});
			in_cart.target = items.filter(({ properties }) => {
				return properties['ノベルティ対象商品'] != undefined && properties['ノベルティ対象商品'] == code;
			});
			in_cart.total = in_cart.target.reduce((sum, { original_line_price }) => sum + original_line_price, 0);

			/* || (start !== '' && new Date(start) > this.now) || (end !== '' && new Date(end) < this.now) */
			if (min > 0 && min > in_cart.total) {
				if (in_cart.novelty.length > 0) {
					this.changes.push({ id: id + '', quantity: 0 });
				}
				continue;
			}

			novelty.classList.remove('hide');

			if (stock == 0) {
				novelty.classList.add('not-selected');
				this.error.push(novelty.querySelector('.cart__item--title').innerHTML);
			}

			if (in_cart.novelty.length > 0) {
				checkbox.checked = true;
			}

			checkbox.addEventListener('change', async ({ target }) => {
				this.form.querySelector('[name="checkout"]').disabled = true;

				if (target.checked === true) {
					CI.addItem([{ id, properties: { 'ノベルティ商品': code }, quantity: 1 }]).then(() => location.reload());
				} else {
					CI.changeCart({ id: id + '', quantity: 0 }).then(() => location.reload());
				}
			});
		}

		in_cart.novelty = items.filter(({ properties }) => properties['ノベルティ商品'] !== undefined && properties['ノベルティ商品'] !== '');
		for (const { id, properties } of in_cart.novelty) {
			const code = properties['ノベルティ商品'];
			in_cart.target = items.filter(({ properties }) => properties['ノベルティ対象商品'] !== undefined && properties['ノベルティ対象商品'] === code);
			if (in_cart.target.length === 0) {
				this.changes.push({ id: id + '', quantity: 0 });
			}
		}

		if (items.length - this.changes.length === 0) {
			await CI.clearCart();
			location.reload();
			return;
		}

		if (this.error.length > 0) {
			this.msg.classList.remove('hide');
			this.msg.innerHTML = [...new Set(this.error)].join() + 'は現在選択することができません。';
		}

		if (this.changes.length > 0) {
			await Promise.all(this.changes.map(e => CI.changeCart(e)));
			document.dispatchEvent(new CustomEvent('cart:build'));
		}

		if (this.container.querySelectorAll('.novelty--item:not(.hide').length > 0) {
			this.container.classList.remove('hide');
		}
	};

	async checkout({ items }) {
		const novelty_fields = document.querySelectorAll('#cart-novelty .novelty--item');
		const items_novelties = items.filter(({ properties }) => {
			return properties['ノベルティ商品'] != undefined && properties['ノベルティ商品'] !== '';
		});

		for (const { id, properties, title } of items_novelties) {
			const handle = properties['ノベルティ商品'];
			const line = [...novelty_fields].filter(e => e.dataset.code === handle)[0];

			if (line === null || line === undefined) {
				continue;
			}

			const { stock, min } = line.dataset; /* start, end */
			const total = items.filter(e => {
				return e.properties['ノベルティ対象商品'] != undefined && e.properties['ノベルティ対象商品'] === handle;
			}).reduce((sum, { original_line_price }) => sum + original_line_price, 0);

			if (stock == 0 || (min > 0 && min > total)) {
				alert(`${title}は現在ご利用いただけません。`);
				await CI.changeCart({ id: id + '', quantity: 0 });
				location.reload();
				return true;
			}
		}

		const novelties = await (await fetch('/?view=novelty')).json();
		const target_novelties = items.filter(({ properties }) => properties['ノベルティ商品'] !== undefined && properties['ノベルティ商品'] !== '');
		for (const { id, properties, title } of target_novelties) {
			const handle = properties['ノベルティ商品'];
			const blink_novelties = Object.entries(novelties).filter(e => e[0] === handle);
			if (blink_novelties.length === 0) {
				alert(`${title}は現在ご利用いただけません。`);
				await CI.changeCart({ id: id + '', quantity: 0 });
				location.reload();
				return true;
			}
		}

		return false;
	};
};

// General: Check Reserved
class CheckReserved {
	msg = 'カート内に同時決済ができない商品が含まれています。\n\n・通常商品と予約商品を同時にカートに入れることはできません。\n・異なる商品番号の予約商品を同時にカートに入れることはできません。\n・同じ商品番号の予約商品でも他のカラー・サイズと同時にカートに入れることはできません。\n\n別々にご購入をお願いいたします。';
	
	constructor(form) {
		this.form = form;
	};

	submit({ items }) {
		const formdata = new FormData(this.form);
		const location = formdata.get('properties[location]');
		const gift = formdata.get('properties[ギフトラッピング]');

		this.count = 0;

		for (const { properties, variant_id } of items) {
			if (properties.gift !== undefined && gift === 'true') {
				this.count++;
				continue;
			}

			if (properties.location !== undefined) {
				if (properties.location !== location) {
					this.count++;
					continue;
				}

				if (properties.location === location && location === '予約在庫') {
					if (variant_id != this.form.dataset.variant) {
						this.count++;
						continue;
					}
				}
			}
		}

		if (this.count > 0) {
			alert(this.msg);
			return true;
		}

		return false;
	};

	checkout({ items }) {
		const usually = items.filter(({ properties }) => properties.location !== undefined && properties.location === '通常在庫');
		const reserve = items.filter(({ properties }) => properties.location !== undefined && properties.location === '予約在庫');

		if (usually.length > 0 && reserve.length > 0) {
			alert(this.msg);
			return true;
		}

		return false;
	};
};

// Coupon
document.addEventListener('DOMContentLoaded', () => {
	CI.Coupon = new class Coupon {
		constructor() {
			const container = document.querySelector('#coupon');
			if (container === null) {
				return;
			}

			CI.now().then(now => {
				for (const e of [...document.querySelectorAll('.coupon--item')]) {
					const { start, end } = e.dataset;

					if (
						(start !== '' && new Date(start) > now) ||
						(end !== '' && new Date(end) < now)
					) {
						e.remove();
					}
				}

				const emptyMessage = 'ご利用可能なクーポンはありません。';
				for (const grid of [...container.querySelectorAll('.coupon--grid')]) {
					if (grid.querySelector('.coupon--item')) continue;
					if (grid.querySelector('blockquote')) continue;
					const msg = CI.create('blockquote', { className: 'text-center', innerText: emptyMessage });
					msg.style.margin = '0';
					grid.append(msg);
				}

				container.classList.remove('hide');
			});

			for (const form of [...document.querySelectorAll('[data-coupon-form]')]) {
				const error = form.querySelector('.error');
				const submit = form.querySelector('button');

				form.addEventListener('submit', async e => {
					e.preventDefault();

					error.classList.add('hide');
					submit.classList.add('btn--loading');

					const args = { method: 'post', header: { 'Content-Type': 'multipart/form-data' }, body: new FormData(form) };
					const res = await (await fetch('/apps/front-api-coupon-tag-delete/coupon_tag_delete', args)).json();

					if (res.success === false) {
						error.classList.remove('hide');
						error.innerText = res.message;
						submit.classList.remove('btn--loading');
						return;
					}

					form.classList.add('hide');
					form.nextElementSibling.classList.remove('hide');
					document.querySelector('[data-code=""]').remove();

					if (document.querySelectorAll('.coupon--grid > .coupon').length === 0) {
						document.querySelector('.coupon--grid').append(CI.create('blockquote', { className: 'text-center', innerText: 'ご利用可能なクーポンはありません。' }));
					}
				});
			}
		};

		closeModal(id, boolean = false) {
			document.querySelector(`[data-modal='${id}']`).classList.add('hide');

			if (boolean === true) {
				document.querySelector('[data-modal="cart-coupon"]').classList.add('hide');
			}
		};

		saveClipBoard(code) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(code);
				return;
			}
			const input = CI.create('input', { value: code });
			input.select();
			document.execCommand('copy');
		};
	};
});

// Create Birthday
class CreateBirthday {
	offset = 100;

	constructor(form) {
		this.year = form.querySelector('[data-year]');
		this.month = form.querySelector('[data-month]');
		this.day = form.querySelector('[data-day]');

		new Promise(resolve => resolve())
			.then(async () => {
				this.now = await CI.now();
				this.appendYear();
				this.appendMonth();
				this.appendDay();
			});
	};

	appendYear() {
		const selected = this.year.dataset.selected;
		if (selected !== undefined && selected !== '') {
			this.year.append(CI.create('option', { innerText: selected + '年' , value: selected }));
			return;
		}
		this.year.append(CI.create('option', { innerText: '年', value: '' }));

		const years = [];
		for (const i in [...Array(this.offset)]) {
			years.push(this.now.getFullYear() - (this.offset - 1 - +i));
		}

		for (const y of years.reverse()) {
			this.year.append(CI.create('option', { innerText: y + '年', selected: y === 2000, value: y}));
		}

		this.year.addEventListener('change', () => this.replaceDay());
	};

	appendMonth() {
		const selected = this.month.dataset.selected;
		if (selected !== undefined && selected !== '') {
			this.month.append(CI.create('option', { innerText: selected, value: selected }));
			return;
		}

		this.month.innerHTML = '';
		this.month.append(CI.create('option', { innerText: '月', value: '' }));

		for (const i in [...Array(12)]) {
			const n = +i + 1;
			this.month.append(CI.create('option', { innerText: n + '月', value: n }));
		}

		this.month.addEventListener('change', () => this.replaceDay());
	};

	appendDay(len = null) {
		const selected = this.day.dataset.selected;
		if (selected !== undefined && selected !== '') {
			this.day.append(CI.create('option', { innerText: selected, value: selected }));
			return;
		}

		this.day.innerHTML = '';
		this.day.append(CI.create('option', { innerText: '日', value: '' }));

		if (len === null) {
			len = this.getLastDay();
		}
		if (isNaN(len)) {
			len = 31;
		}

		for (const i in [...Array(len)]) {
			const n = +i + 1;
			this.day.append(CI.create('option', { innerText: n + '日', value: n }));
		}
	};

	replaceDay() {
		if (this.month.querySelector('option:checked').value === '') {
			return;
		}

		this.appendDay(this.getLastDay());
	};

	getLastDay() {
		const y = this.year.querySelector('option:checked');
		const m = this.month.querySelector('option:checked');
		return new Date(y.value !== '' ? y.value : this.now.getFullYear(), m.value, 0).getDate();
	};
};

class GiftWrapping {
	constructor(form) {
		this.form = form;
	};

	setGiftProducts(modal) {
		const button = modal.querySelector('.inner button');
		button.addEventListener('click', async () => {
			button.classList.add('btn--loading');

			const selected = modal.querySelector('input:checked');

			if (selected === null) {
				alert('ギフトラッピングをお選びください。');
				button.classList.remove('btn--loading');
				return;
			}

			this.form.querySelector('[name="checkout"]').disabled = true;

			const { items } = await CI.getCart(), updates = {};

			for (const { properties } of items) {
				if (+properties?.gift > 0) {
					updates[properties.gift] = 0;
				}
			}

			if (Object.keys(updates).length > 0) {
				await CI.updateCart({ updates });
			}

			CI.addItem([{ id: selected.value, properties: { gift: selected.value }, quantity: 1 }]).then(() => {
				document.dispatchEvent(new CustomEvent('cart:build'));

				alert('ギフトラッピングを追加しました。');

				modal.classList.add('hide');
				location.reload();
			});
		});
	};

	checkout({ items }) {
		const not_gift = [], gift = [];
		for (const item of items) {
			const { properties } = item;

			if (properties.gift !== undefined && properties.gift !== '') {
				gift.push(item);
			}

			if (properties['ギフトラッピング'] !== undefined && properties['ギフトラッピング'] === '不可') {
				not_gift.push(item);
			}
		}

		if (not_gift.length > 0 && gift.length > 0) {
			alert('ギフトサービスとギフトラッピング不可商品が同梱されています。\nどちらかを削除した上で改めてチェックアウトへお進みください。');
			return true;
		}

		return false;
	};

	async update({ items, item_count }) {
		for (const { properties } of items) {
			if (item_count === 1 && (properties.gift !== undefined && +properties.gift > 0)) {
				await CI.clearCart();
				location.reload();
				break;
			}
		}
	};
};

// Insert Address
class InsertAddress {
	constructor(form) {
		this.form = form;
		const trigger = this.form.querySelector('.InsertAddress');
		trigger.addEventListener('click', async e => {
			e.preventDefault();

			await this.getAddress();
		})
	};

	async getAddress() {
		const zip = this.form.querySelector('[name*="zip"]');
		const postcode = zip.value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, '');
		if (postcode.length !== 7) {
			alert('正しい7桁の郵便番号を入力してください。');
			return;
		}

		const formdate = new FormData();
		formdate.append('zip', postcode);

		const province = this.form.querySelector('[name*="province"]');
		const city = this.form.querySelector('[name*="city"]');
		const address = this.form.querySelector('[name*="address1"]');

		const classToggle = (e, boolean = false) => {
			if (e === null) {
				return;
			}
			if (boolean === true) {
				setTimeout(() => e.classList.remove('disabled'), 400);
				return;
			}
			e.classList.add('disabled');
		};

		try {
			classToggle(province);
			classToggle(city);
			classToggle(address);

			const args = { method: 'post', header: { 'Content-Type': 'multipart/form-data' }, body: formdate };
			const res = await (await fetch('/apps/front-api-zip/zip', args)).json();

			if (res.length === 0) {
				classToggle(province, true);
				classToggle(city, true);
				classToggle(address, true);
				return;
			}

			if (province !== null) {
				for (const o of [...province.querySelectorAll('option')]) {
					o.selected = false;
					if (o.innerHTML === res[0].province) {
						o.selected = true;
					}
				}
				classToggle(province, true);
			}
			if (city !== null) {
				city.value = res[0].city;
				classToggle(city, true);
			}
			if (address !== null) {
				address.value = res[0].address1;
				classToggle(address, true);
			}
		} catch (err) {
			alert('郵便番号が検索出来ませんでした。')
			classToggle(province, true);
			classToggle(city, true);
			classToggle(address, true);
		}
	};
};
// General: Modal
document.addEventListener('DOMContentLoaded', () => {
	CI.Modal = new class Modal {
		constructor() {
			for (const trigger of [...document.querySelectorAll('[data-modal-opener]')]) {
				const target = document.querySelector(`[data-modal="${trigger.dataset.modalOpener}"]`);
				if (target === null) {
					continue;
				}

				trigger.addEventListener('click', e => {
					e.preventDefault();
					target.classList.remove('hide');
				});

				for (const close of [...target.querySelectorAll('.__close')]) {
					close.addEventListener('click', e => {
						e.preventDefault();
						target.classList.add('hide');
					});
				}
			}
		};
	};
});

document.addEventListener('DOMContentLoaded', () => {
	// /pages/guide
	if (location.pathname.includes('/pages/guide')) {
		new class PagesGuide {
			containers = document.querySelectorAll('.guide-content article');
			links = document.querySelectorAll('.guide-menus a[href*="/pages/guide"]');

			constructor() {
				this.hash = new URL(location).hash.slice(1);

				if (this.hash !== '') {
					for (const e of [...this.links]) {
						if (e.href.includes(this.hash)) {
							e.classList.add('is-active');
						}
					}

					for (const e of [...this.containers]) {
						e.classList.add('hide');
					}
					document.querySelector(`.guide-content article#${this.hash}`).classList.remove('hide');;
				}

				for (const link of [...this.links]) {
					link.addEventListener('click', e => {
						e.preventDefault();

						this.hash = new URL(link.href).hash.slice(1);

						for (const link of [...this.links]) {
							link.classList.remove('is-active');
						}
						link.classList.add('is-active');

						for (const container of [...this.containers]) {
							container.classList.add('hide');
						}

						const target = document.querySelector(`.guide-content article#${this.hash}`);
						if (target !== null) {
							target.classList.remove('hide');
							location.hash = this.hash;
							setTimeout(() => window.scroll({ top: 0, behavior: 'smooth' }), 100);
						}
					});
				}
			};
		};
	}
});


// const getOffset = (element) => {
//   if (element.hash === "") return 0;
//   let targetElement = document.querySelector(element.hash);
//   return targetElement.getBoundingClientRect().top + scrollY;
// }

// class Anchor {
//   constructor(element, _defaultClass = ".l-header") {
//     this.anchorWrap = document.querySelector(element);
//     this.anchors = this.anchorWrap.querySelectorAll("a");
//     this.header = document.querySelector(_defaultClass);
//   }
//   smoothScroll() {
//     this.anchors.forEach((anchor) => {
//       anchor.addEventListener("click", (e) => {
//         e.preventDefault();

//         const targetTop = getOffset(anchor) - this.header.clientHeight;

//         scrollTo({
//           top: targetTop,
//           behavior: "smooth",
//         });
//       });
//     });
//   }
// }

// const sizeGuideAnchorScroll = () => {
//   const sizeGuideAnchor = new Anchor(".size-guide__anchor-lists", "#SiteHeader");
// sizeGuideAnchor.smoothScroll();
// }

// const guideAccordion = () => {
//   const currentHash = location.hash.replace("#", "");
//   const contentBlocks = document.querySelectorAll(".contents_block-detail");

//   if (currentHash === "") {
//     [...contentBlocks][0].style.display = "block";
//   }

//   contentBlocks.forEach((contentBlock) => {
//     if (contentBlock.id === currentHash) {
//       contentBlock.style.display = "block";
//     }
//   });

//   const tabHash = document.querySelector(
//     `.guide-accordion__sub-menu li > a[href*="#${currentHash}"]`
//   );
//   const closest = tabHash.closest(".guide-accordion__sub-menu");

//   closest.style.display = "block";
//   tabHash.classList.add("is-active");

//   const subAnchors = document.querySelectorAll(".guide-accordion__sub-menu a");

//   subAnchors.forEach((subAnchor) => {
//     subAnchor.addEventListener("click", () => {
//       const id = subAnchor.hash.replace("#", "");
//       const detailBlock = document.getElementById(id);
//       contentBlocks.forEach((contentBlock) => {
//         if (detailBlock === contentBlock) {
//           contentBlock.style.display = "block";
//         } else {
//           contentBlock.style.display = "none";
//         }
//       });
//       const anchors = document.querySelectorAll(".guide-accordion__sub-menu a");
//       anchors.forEach((anchor) => {
//         if (subAnchor === anchor) {
//           anchor.classList.add("is-active");
//         } else {
//           anchor.classList.remove("is-active");
//         }
//       });
//     });
//   });

//   const my_accordion = new Accordion(".guide-accordion__primary-item");
//   my_accordion.accordion(".guide-accordion__sub-menu");

// };

// const sizeGuideAccordion = () => {
//   const my_accordion = new Accordion(".size-guide__content","is-open","flex");
//   my_accordion.accordion(".size-guide__items", ".js-trigger");
// }

// const changeMediaSize = () => {
//   const mql = window.matchMedia("(max-width: 769px)");
//   let count = 0;

//   const match = (e) => {
//     if (mql.matches) {
//       count++;
//       if (count <= 1) {
//         sizeGuideAccordion();
//       }
//     } else {
//       sizeGuideAnchorScroll();
//       const contents = document.querySelectorAll(".size-guide__items");
//       for (const content of contents) {
//         if (content.style.display === "none") {
//           content.style.removeProperty("display");
//         }
//       }
//     }
//   }

//   mql.addEventListener("change", match);
//   window.addEventListener("load",match);

// }


// window.addEventListener("DOMContentLoaded", () => {

//   const sectionTitle = document.querySelector(".section-header__title").textContent;

//   switch (sectionTitle) {
//     case "ご利用ガイド":
//       guideAccordion();
//       break;
//     case "サイズガイド":
//       changeMediaSize();
//       break;
//     default:
//       return;
//   }

// });


// class Accordion {
//   constructor(target, addClass = "is-open", style = "block") {
//     this.accordionContentAll = document.querySelectorAll(target);
//     this.style = style;
//     this.addClass = addClass;
//   }

//   slideUp(parent, element, duration) {
//     element.style.height = element.offsetHeight + "px";
//     element.offsetHeight;
//     element.style.transitionProperty = "height, margin, padding";
//     element.style.transitionDuration = duration + "ms";
//     element.style.transitionTimingFunction = "ease";
//     element.style.overflow = "hidden";
//     element.style.height = 0;
//     element.style.paddingTop = 0;
//     element.style.paddingBottom = 0;
//     element.style.marginTop = 0;
//     element.style.marginBottom = 0;
//     parent.classList.remove(this.addClass);
//     setTimeout(() => {
//       element.style.display = "none";

//       element.style.removeProperty("height");
//       element.style.removeProperty("padding-top");
//       element.style.removeProperty("padding-bottom");
//       element.style.removeProperty("margin-top");
//       element.style.removeProperty("margin-bottom");
//       element.style.removeProperty("overflow");
//       element.style.removeProperty("transition-duration");
//       element.style.removeProperty("transition-property");
//       element.style.removeProperty("transition-timing-function");
//     }, duration);
//   }

//   slideDown(parent, element, duration) {
//     parent.classList.add(this.addClass);
//     element.style.removeProperty("display");
//     let display = window.getComputedStyle(element).display;
//     if (display === "none") {
//       display = this.style;
//     }
//     element.style.display = display;
//     let height = element.offsetHeight;
//     element.style.overflow = "hidden";
//     element.style.height = 0;
//     element.style.paddingTop = 0;
//     element.style.paddingBottom = 0;
//     element.style.marginTop = 0;
//     element.style.marginBottom = 0;
//     element.offsetHeight;
//     element.style.transitionProperty = "height, margin, padding";
//     element.style.transitionDuration = duration + "ms";
//     element.style.transitionTimingFunction = "ease";
//     element.style.height = height + "px";
//     element.style.removeProperty("padding-top");
//     element.style.removeProperty("padding-bottom");
//     element.style.removeProperty("margin-top");
//     element.style.removeProperty("margin-bottom");
//     setTimeout(() => {
//       element.style.removeProperty("height");
//       element.style.removeProperty("overflow");
//       element.style.removeProperty("transition-duration");
//       element.style.removeProperty("transition-property");
//       element.style.removeProperty("transition-timing-function");
//     }, duration);
//   }

//   slideToggle(parent, element, duration = 500) {
//     if (window.getComputedStyle(element).display === "none") {
//       return this.slideDown(parent, element, duration);
//     } else {
//       return this.slideUp(parent, element, duration);
//     }
//   }

//   accordion(content, _default = 'a') {
//     this.accordionContentAll.forEach((accordionContent, i) => {
//       const element = accordionContent.querySelector(content);
//       if (element === null) return;
//       const anchor = accordionContent.querySelector(_default);
//       anchor.addEventListener("click", (e) => {
//         e.preventDefault();
//         this.slideToggle(accordionContent, element);
//       });
//     });
//   }
// }





// General: Product History
document.addEventListener('DOMContentLoaded', () => {
	CI.ProductHistory = new class ProductHistory {
		items = [];
		limit = 15;

		constructor() {
			for (const [handle, { featuredImage, url }] of Object.entries(theme.recentlyViewed.recent)) {
				this.items.push({ featuredImage, url });
			}
			this.items = this.items.reverse().slice(0, this.limit);

			const containers = document.querySelectorAll('.product-history');
			for (const container of [...containers]) {
				if (this.items.length === 0) {
					container.remove();
				}

				this.createHistory(container);
			}
		};

		createHistory(container) {
			container.append(CI.create('h2', { innerHTML: 'CHECKED ITEMS' }));

			const inner = CI.create('div', { className: 'container' });
			container.append(inner);

			for (const { featuredImage, url } of this.items) {
				inner.append(CI.create('a', { href: url, innerHTML: `<img src="${featuredImage.replace('_{width}x', '')}">` }));
			}

			if (this.items.length > 5) {
				const hash = Math.floor(Math.random() * 10000000);
				inner.before(CI.create('input', { className: 'hide', id: 'search-history-' + hash, type: 'checkbox' }));

				const label = CI.create('label', { className: '', innerHTML: 'VIEW MORE' });
				label.setAttribute('for', 'search-history-' + hash);
				container.append(label);
			}
		};
	};
});

// General: Purchase Limit
class PurchaseLimit {
	constructor(form) {
		this.form = form;
	};

	submit({ items }) {
		const { handle } = this.form.dataset;

		const formdata = new FormData(this.form);
		const limit = formdata.get('properties[購入制限数]');

		if (limit == 'null' || limit == 0) {
			return false;
		}

		const count = items.reduce((sum, item) => {
			return sum + (item.handle == handle ? item.quantity : 0);
		}, 0);

		if (count + 1 > +limit) {
			alert('購入数の上限に達している為、カートに入れることはできません。');
			return true;
		}
		return false;
	};

	checkout({ items }) {
		for (const { product_id, properties } of items) {
			const total = items.filter(e => e.product_id === product_id).reduce((sum, { quantity }) => sum + quantity, 0);
			if (properties['購入制限数'] !== undefined && properties['購入制限数'] !== '' && properties['購入制限数'] != 0 && total > +properties['購入制限数']) {
				alert('購入制限数以上のカートインが確認されました。\n該当の商品は個数を減らしレジへお進みください。');
				return true;
			}
		}
		return false;
	};
};

// General: Search History
CI.SearchHistory = new class SearchHistory {
	local = 'calif--search-history';
	history = [];
	max = 5;

	initialize() {
		const storage = localStorage.getItem(this.local);
		if (storage !== null && storage !== '') {
			this.history = storage.split(',');
		}

		for (const wrapper of document.querySelectorAll('.search-history')) {
			this.detectsAndSaveHistory(wrapper);
			this.createHistoryItems(wrapper);
		}
	};

	detectsAndSaveHistory(wrapper) {
		const form = wrapper.closest('form');
		const input = form.querySelector('[name="q"]');
		const button = form.querySelector('.delete');

		if (input.value !== '') {
			button.classList.remove('hide');
		}

		for (const evt of ['input', 'change', 'keyup', 'keydown']) {
			input.addEventListener(evt, () => {
				if (input.value !== '') {
					button.classList.remove('hide');
					return;
				}
				button.classList.add('hide');
			});
		}

		input.addEventListener('focus', () => form.classList.add('is-focused'));
		input.addEventListener('focusout', () => setTimeout(() => form.classList.remove('is-focused'), 400));

		button.addEventListener('click', () => {
			for (const f of [...document.querySelectorAll('form[action="/search"]')]) {
				f.querySelector('[name="q"]').removeAttribute('value');
				f.querySelector('.delete').classList.add('hide');
			}
		});


		form.addEventListener('submit', e => {
			e.preventDefault();

			const value = input.value.replace('　', ' ').trim();
			if (value === '' || value === ' ') {
				input.value = '';
				return;
			}

			this.history.push(encodeURIComponent(value));
			this.history = Array.from(new Set(this.history));
			if (this.history.length > this.max) {
				this.history = [...this.history].splice(this.history.length - this.max, this.history.length);
			}

			wrapper.classList.add('has-history');
			this.createHistoryItems(wrapper);

			localStorage.setItem(this.local, this.history);

			form.submit();
		});
	};

	createHistoryItems(wrapper) {
		if (this.history.length === 0) {
			return;
		}

		wrapper.classList.add('has-history');

		const container = wrapper.querySelector('.container');
		container.innerHTML = '';

		for (const q of this.history) {
			const item = CI.create('div', { className: 'history--item' });
			item.dataset.q = q;
			container.prepend(item);

			item.append(CI.create('a', { href: `/search?q=${q}&type=product`, innerHTML: decodeURIComponent(q) }));

			const close = CI.create('button', { type: 'button' });
			close.addEventListener('click', () => {
				for (const item of [...container.querySelectorAll(`[data-q="${q}"]`)]) {
					item.remove();
				}

				this.history = this.history.filter(e => e !== q);
				localStorage.setItem(this.local, this.history);

				if (this.history.length === 0) {
					for (const e of [...document.querySelectorAll('.search-history')]) {
						wrapper.classList.remove('has-history');
					}
				}
			});
			item.append(close);
		}
	};
};

document.addEventListener('DOMContentLoaded', () => {
	CI.SearchHistory.initialize();
});
window.addEventListener('beforeunload', () => {
	CI.SearchHistory.initialize();
});
window.addEventListener('pagehide', () => {
	CI.SearchHistory.initialize();
});
window.addEventListener('unload', () => {
	CI.SearchHistory.initialize();
});

// General: Swiper Slider
class SwiperSlider {
	args = {
		breakpoints: {
			576: {
				slidesPerView: 1.4,
			},
			992: {
				spaceBetween: 12,
			},
			1200: {
				slidesPerView: 2.4,
			},
			1400: {
				slidesPerView: 3.2,
			},
			1800: {
				slidesPerView: 4.2,
			}
		},
		centeredSlides: true,
		loop: true,
		pagination: {
			el: '.column-slider-pagination',
			clickable: true
		},
		slidesPerView: 1.2,
		spaceBetween: 10,

		slideClass: 'column-slider-slide',
		wrapperClass: 'column-slider-wrapper'
	};

	constructor(selector = '', args = {}) {
		const slider = document.querySelector(selector);
		if (slider === null) {
			return;
		}

		Object.assign(this.args, args);
		return new Swiper(slider, this.args);
	};
};

//  Validation
class Validation {
	constructor(form) {
		this.form = form;
		this.form.classList.add('original--validation');
	};

	checkValidation() {
		for (const e of [...this.form.querySelectorAll('.error')]) {
			e.classList.remove('error');
		}

		const msg = this.form.querySelector('.err_msg');
		if (msg !== null) {
			msg.classList.add('hide');
			msg.innerHTML = '';
		}

		const err = this.checkInputField(this.form.querySelectorAll('[data-varidated]'));
		if (err.length === 0) {
			return false;
		}

		if (msg !== null) {
			msg.classList.remove('hide');
			msg.innerHTML = err.join('<br>');
		} else {
			alert(err.join('\n'));
		}

		const top = this.form.getBoundingClientRect().top + window.pageYOffset - 80;
		window.scroll({ top, behavior: 'smooth' });
		return true;
	};

	checkInputField(fields) {
		const err = [];
		for (const field of [...fields]) {
			const handle = field.dataset.varidated;

			if (handle === 'names') {
				const [lastname, firstname] = [...field.querySelectorAll('input')];

				if (lastname.value === '') {
					err.push('お名前（姓）が入力されていません。');
					lastname.classList.add('error');
				}
				if (firstname.value === '') {
					err.push('お名前（名）が入力されていません。');
					firstname.classList.add('error');
				}
				continue;
			}

			if (handle === 'kanas') {
				const [lastname, firstname] = [...field.querySelectorAll('input')];

				if (lastname.value === '') {
					err.push('フリガナ（姓）が入力されていません。');
					lastname.classList.add('error');
				}
				else if (lastname.value.match(/^[ァ-ヶー　ｦ-ﾟ]*$/) === null) {
					err.push('不正な形式のフリガナ（姓）です。');
					lastname.classList.add('error');
				}
				if (firstname.value === '') {
					err.push('フリガナ（名）が入力されていません。');
					firstname.classList.add('error');
				}
				else if (firstname.value.match(/^[ァ-ヶー　ｦ-ﾟ]*$/) === null) {
					err.push('不正な形式のフリガナ（名）です。');
					firstname.classList.add('error');
				}
				continue;
			}

			if (handle === 'email') {
				const email = field.querySelector('input');
				const validAddress = () => {
					return email.value.match(/^[a-zA-Z0-9-_]+[a-zA-Z0-9-_.+?/]+[a-zA-Z0-9-_+?/]@[a-zA-Z0-9]+[a-zA-Z0-9-_.+?/]+(?:\.[a-zA-Z0-9-]+)*$/i) === null || email.value.match(/[./]{2,}/i) !== null
				};

				if (email.value === '') {
					err.push('メールアドレスが入力されていません。');
				}
				else if (validAddress()) {
					err.push('不正な形式のメールアドレスです。');
				}

				if (email.value === '' || validAddress()) {
					email.classList.add('error');
				}
				continue;
			}

			if (handle === 'password') {
				const password = field.querySelector('input');
				const regex = /^.*[a-zA-Z0-9!"#$%&'()-^\@[;:\],./=~|`{+*}<>?_]*$/i;

				if (password.value === '') {
					err.push('パスワードが入力されていません。');
				}
				else if (password.value.length < 5) {
					err.push('パスワードの文字数が5文字未満です。');
				}
				else if (password.value.match(regex) === null) {
					err.push('不正な形式のパスワードです。');
				}

				if (password.value === '' || password.value.length < 5 || password.value.match(regex) === null) {
					password.classList.add('error');
				}
				continue;
			}

			if (handle === 'birthday') {
				const selected = field.querySelectorAll('option:checked');

				if ([...selected].filter(e => e.value === '').length > 0) {
					err.push('誕生日が選択されていません。');
					for (const e of [...selected]) {
						e.closest('select').classList.add('error');
					}
				}
				continue;
			}

			if (handle === 'gender') {
				const [men, women, other] = field.querySelectorAll('input');
				const filter = [men, women, other].filter(e => e.checked === true);

				if (filter.length === 0) {
					err.push('性別が選択されていません。');
					for (const e of [men, women, other]) {
						e.nextElementSibling.classList.add('error');
					}
				}
				continue;
			}

			if (handle === 'height') {
				const height = field.querySelector('option:checked');
				if (height.value === '') {
					err.push('身長が選択されていません。');
					height.closest('select').classList.add('error');
				}
				continue;
			}

			if (handle === 'zip') {
				const zip = field.querySelector('input');
				zip.value = zip.value.replace(/-/g, '');
				zip.value = zip.value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));

				if (zip.value === '') {
					err.push('郵便番号が入力されていません。');
				} else if (zip.value.length < 7) {
					err.push('郵便番号の桁数が足りていません。');
				} else if (zip.value.match(/^[0-9]{7}$/) === null) {
					err.push('不正な形式の郵便番号です。');
				}

				if (zip.value === '' || zip.value.length < 7 || zip.value.match(/^[0-9]{7}$/) === null) {
					zip.classList.add('error');
				}
				continue;
			}

			if (handle === 'province') {
				const pref = field.querySelector('option:checked');
				if (pref.value === '') {
					err.push('都道府県が選択されていません。');
					pref.closest('select').classList.add('error');
				}
				continue;
			}

			if (handle === 'city') {
				const city = field.querySelector('input');

				if (city.value === '') {
					err.push('市区町村が入力されていません。');
					city.classList.add('error');
				}
				continue;
			}

			if (handle === 'address1') {
				const address = field.querySelector('input');

				if (address.value === '') {
					err.push('町名・番地が入力されていません。');
					address.classList.add('error');
				}
				continue;
			}

			if (handle === 'phone') {
				const tel = field.querySelector('input');
				tel.value = tel.value.replace(/-/g, '');

				if (tel.value === '') {
					err.push('電話番号が入力されていません。');
					tel.classList.add('error');
				}
				continue;
			}

			if (handle === 'privacy') {
				const checkbox = field.querySelector('input:checked');

				if (checkbox === null) {
					err.push('利用規約・プライバシーポリシーの同意をお願いします。');
					field.querySelector('[for="privacy"]').classList.add('error');
				}
				continue;
			}
		}

		return err;
	};
};
// Product: Accordion Block
// document.addEventListener('DOMContentLoaded', () => {
// 	CI.ProductAccordionBlock = new class ProductAccordionBlock {
// 		constructor() {
// 			this.initialize();
// 		};

// 		initialize() {
// 			for (const block of [...document.querySelectorAll('.product-block--accordion')]) {
// 				const trigger = block.querySelector('[data-accordion]');
// 				trigger.addEventListener('click', e => {
// 					e.preventDefault();
// 					block.classList.toggle('is-active');
// 				});

// 				const container = block.querySelector('[data-accordion-container]');
// 				block.getElementsByClassName.cssText = `--height: ${container.scrollHeight}px;`;
// 			}
// 		}
// 	};
// 	window.addEventListener('resize', () => CI.ProductAccordionBlock.initialize());
// });

// Product: Item Stock
class ItemStock {
	constructor(id) {
		this.container = document.querySelector(`[data-block="${id}"]`);
		this.modal = this.container.querySelector('.item-stock-modal--result');

		this.shoplist = this.container.dataset.shoplist;
		this.inventory = +this.container.dataset.inventory;

		this.json = this.container.querySelector(`#${id}-json`);
		this.json = JSON.parse(this.json.innerHTML);

		this.createShopListModal();
	};

	async createShopListModal() {
		try {
			const res = await (await fetch(this.shoplist)).json();
			const shoplist = res.filter(s => s.shopcode !== '' && s.shopcode !== 'null' && s.publish === '掲載');
			if (shoplist.length === 0) {
				this.container.remove();
				return;
			}

			this.form = this.container.querySelector('.item-stock-modal--form');
			this.submit = this.form.querySelector('[type="submit"]');

			this.form.addEventListener('change', () => {
				const selected = [];
				const selecters = this.form.querySelectorAll('select');

				for (const s of [...selecters]) {
					if (s.value !== '') {
						selected.push(s.value);
					}
				}

				if (selected.length === selecters.length) {
					this.submit.disabled = false;
					return;
				}

				this.submit.disabled = true;
			});

			this.form.addEventListener('submit', e => {
				e.preventDefault();
				this.runSearch(shoplist);
			});

			this.applyPresetFromUrl();
			this._lastPresetKey = this.getPresetKey();
			this.watchUrlVariant();
		} catch (err) {
			console.error(err);
			this.container.remove();
		}
	};

	runSearch(shoplist) {
		this.submit.classList.add('btn--loading');

		const selected = [];
		const selecters = this.form.querySelectorAll('select');

		for (const s of [...selecters]) {
			if (s.value !== '') {
				selected.push(s.value);
			}
		}

		if (selected.length === selecters.length && selecters.length > 0) {
			const variantKey = selected.join(' / ');
			const has_variants = this.json.filter(({ variant }) => variant === variantKey);

			if (has_variants.length > 0 && has_variants[0].shops.length > 0) {
				this.outputShops(has_variants[0], shoplist);
				return;
			}
		}

		this.modal.innerHTML = CI.string.itemstock.no_result;
		this.submit.classList.remove('btn--loading');
	};

	applyPresetFromUrl() {
		if (!this.form) return false;

		const params = new URLSearchParams(window.location.search);
		const variantParam = params.get('variant');
		const skuParam = params.get('sku');
		let match = null;

		if (variantParam) {
			const variantId = variantParam.trim();
			match = this.json.find((entry) => String(entry.id) === variantId);
		} else if (skuParam) {
			const sku = skuParam.trim();
			match = this.json.find((entry) => entry.sku && entry.sku === sku);
		}

		if (!match) return false;

		const optionValues = match.variant.includes(' / ')
			? match.variant.split(' / ')
			: [match.variant];

		const selects = [...this.form.querySelectorAll('select')];
		selects.forEach((select, index) => {
			const value = optionValues[index];
			if (value === undefined) return;
			const hasOption = [...select.options].some((opt) => opt.value === value);
			if (hasOption) select.value = value;
		});

		this.form.dispatchEvent(new Event('change', { bubbles: true }));

		if (this.submit && !this.submit.disabled) {
			this.form.requestSubmit();
		}

		return true;
	};

	getPresetKey() {
		const params = new URLSearchParams(window.location.search);
		const variantParam = params.get('variant');
		const skuParam = params.get('sku');

		if (variantParam && variantParam.trim() !== '') {
			return `variant:${variantParam.trim()}`;
		}

		if (skuParam && skuParam.trim() !== '') {
			return `sku:${skuParam.trim()}`;
		}

		return '';
	};

	resetPresetState() {
		if (this.modal) {
			this.modal.innerHTML = '';
		}

		if (!this.form) return;

		this.form.querySelectorAll('select').forEach((select) => {
			select.value = '';
		});

		if (this.submit) {
			this.submit.disabled = true;
			this.submit.classList.remove('btn--loading');
		}
	};

	watchUrlVariant() {
		if (!window.__itemStockUrlWatcherInstalled) {
			window.__itemStockUrlWatcherInstalled = true;

			const notifyUrlChange = () => {
				window.dispatchEvent(new Event('itemstock:urlchange'));
			};

			window.addEventListener('popstate', notifyUrlChange);

			['pushState', 'replaceState'].forEach((method) => {
				const original = history[method];
				history[method] = function (...args) {
					const result = original.apply(this, args);
					notifyUrlChange();
					return result;
				};
			});
		}

		this._onUrlChange = () => {
			const presetKey = this.getPresetKey();
			if (presetKey === this._lastPresetKey) return;

			this._lastPresetKey = presetKey;
			this.resetPresetState();

			if (presetKey !== '') {
				this.applyPresetFromUrl();
			}
		};

		window.addEventListener('itemstock:urlchange', this._onUrlChange);
	};

	outputShops({ shops }, shoplist) {
		this.modal.innerHTML = '';

		setTimeout(() => {
			for (const { shopCode, invtyQty } of shops) {
				const shop = shoplist.filter(e => e.shopcode == shopCode);
				if (shop.length === 0) {
					continue;
				}
				const { name, url } = shop[0];
				const e = url === '' ? CI.create('div') : CI.create('a', { href: url, target: '_blank' });

				Object.assign(e, { className: 'item-stock-modal--item', innerHTML: name });

				this.modal.append(e);

				const inventory = CI.create('div', { className: 'inventory' });
				e.append(inventory);

				if (invtyQty === 0) {
					inventory.classList.add('no-stock');
					inventory.innerHTML = CI.string.itemstock.out_of_stock;
					continue;
				}

				if (this.inventory > invtyQty) {
					inventory.classList.add('slightly');
					inventory.innerHTML = CI.string.itemstock.little_stock;
					continue;
				}

				inventory.innerHTML = CI.string.itemstock.in_stock;
			}
			this.submit.classList.remove('btn--loading');
		}, 1000);
	};
};

// Product: Staff Snap
// class ProductStaffSnap {
// 	constructor(section) {
// 		const container = section.querySelector('.staff-snap--container');
// 		const template = section.querySelector('template').content;
// 		Object.assign(this, { container, template });

// 		const ID = container.dataset?.merchantId;
// 		const ProductID = container.dataset?.productId;

// 		fetch(`https://api.staff-start.com/v1/coordinate?merchant_id=${ID}&base_product_code=${ProductID}&count=5`)
// 			.then(r => r.json())
// 			.then(({ item }) => {

// 				if (item.length === 0) {
// 					section.remove();
// 					return;
// 				}

// 				for (const e of item) {
// 					this.createItems(e);
// 				}

// 				section.classList.remove('hide');
// 			})
// 			.catch(err => {
// 				section.remove();
// 			});
// 	};

// 	createItems({ cid, image_url, label_name, user_name, user_height }) {
// 		const item = this.template.cloneNode(true).querySelector('.grid__item');
// 		this.container.append(item);

// 		item.querySelector('a').href = `/apps/staffstart/coordinates/${cid}`;
// 		item.querySelector('.snap').src = image_url;
// 		item.querySelector('.grid-product__vendor').innerHTML = label_name;
// 		item.querySelector('.name').innerHTML = user_name;
// 		item.querySelector('.height').innerHTML = `${user_height}cm`;
// 	};
// };

// Cart: Cart Abandonment
class CartAbandonment {
	items = [];
	param = new URLSearchParams(location.search);

	constructor() {
		if (this.param.has('view') !== true || this.param.get('view') !== 'mail' || this.param.has('item') !== true) {
			// this.removeParam();
			// location.href = '/cart';
			// return;
		}
		this.init();
	};

	async init() {
		try {
			for (const value of this.param.get('item').split(',')) {
				const [id, quantity] = value.split(':');
				this.items.push({ id, quantity });
			}

			if (this.items.length === 0) {
				return this.removeParam();
			}

			await CI.clearCart();
			this.cart = await CI.addItem(this.items);

			if (this.cart?.errors !== undefined) {
				alert(this.cart.errors);
			}

			this.cart = await CI.getCart();
			if (this.cart.item_count === 0) {
				this.removeParam();
				location.href = '/';
				return;
			}

			this.items = this.items.filter(item => {
				return this.cart.items.filter(({ id }) => id == item.id).length;
			});

			await Promise.all(this.items.map(async item => {
				const in_cart_item = this.cart.items.filter(({ id }) => id == item.id)[0];
				const variants = await (await fetch(`/products/${in_cart_item.handle}?view=ajax`)).json();
				item.properties = variants.filter(({ id }) => id == item.id)[0].properties;

				if (item.properties['購入制限数'] !== '' && item.quantity > item.properties['購入制限数']) {
					item.quantity = item.properties['購入制限数'];
				}
			}));

			const items = [];
			let err = 0;

			for (const item of this.items) {
				if (items.length === 0) {
					items.push(item);
					continue;
				}

				const { location } = item.properties;
				if (
					(location === '通常在庫' && items.filter(({ properties }) => properties.location === '予約在庫').length > 0) ||
					(location === '予約在庫' && items.length > 0)
				) {
					err++;
					continue;
				}
				items.push(item);
			}

			if (err > 0) {
				alert('同梱不可の商品があります。');
			}
			await CI.clearCart();
			await CI.addItem(items);

			this.cart = await CI.getCart();

			if (this.cart.item_count > 0) {
				this.removeParam();
				history.replaceState('', '', '?' + this.param.toString());
				location.href = '/cart';
				return;
			}

			location.href = '/';
		} catch (err) {
			console.error(err);
		}
	};

	removeParam() {
		this.param.delete('item');
		this.param.delete('view');
		return false;
	};
};
